<template>
  <row>
    <column class="col-lg-2">
      <va-box title="Reports list" theme="box-info" :isBorder="true" widgetType="">
        <div slot="content">
          <input v-if="0>1" type="button" class="btn btn-danger" value="Run Test" style="margin-top: 20px; width: 100%;" @click="test" />
          <h5>Select Report:</h5>
          <select class="form-control" v-model="reportKey" style="padding-left: 0px;">
            <option value=""></option>
            <option v-for="(item,index) in reports" :data="item" :key="index" :value="item['.key']">
              {{ item.Name }}
            </option>
          </select>
        </div>
        <div slot="footer">
          <h5>Filters:</h5>
          <div class="divReportFilter" v-show="$root.isAdmin && report && report.Filters && report.Filters.DealerKey">
            <span>Dealer:</span>
            <select class="form-control" v-model="filters.dealerKey" style="padding-left: 0px;">
              <!--<option value="All" selected="selected">All</option>-->
              <option v-for="(item,index) in sortedDelaers" :value="item.value">{{ item.title }}</option>
            </select>
          </div>
          <div class="divReportFilter" v-show="report && report.Filters && report.Filters.CustomerKey && filters.dealerKey !== 'All' && !$root.isCustomer">
            <span>Customer:</span>
            <select class="form-control" v-model="filters.customerKey" style="padding-left: 0px;">
              <option value="All" selected="selected">All</option>
              <option v-for="(item,index) in customers" :value="item.value">{{ item.title }}</option>
            </select>
          </div>
          <div class="divReportFilter" v-show="report && report.Filters && report.Filters.SiteKey && filters.customerKey !== 'All'">
            <span>Site:</span>
            <select class="form-control" v-model="filters.siteKey" style="padding-left: 0px;">
              <option value="All" selected="selected">All</option>
              <option v-for="(item,index) in sites" :value="item.value">{{ item.title }}</option>
            </select>
          </div>
          <div class="divReportFilter" v-show="report && report.Filters && report.Filters.PrinterKey">
            <span>Printer MAC:</span>
            <input type="text" class="form-control" v-model="filters.printerKey" placeholder="Enter MAC Address" />
          </div>
          <div class="divReportFilter" v-show="report && report.Filters && report.Filters.Monthly">
            <div class="row">
              <span class="col-sm-6">Month:</span>
              <span class="col-sm-6">Year:</span>
            </div>
            <div class="row">
              <div class="col-sm-4">
                <select class="form-control" v-model="filters.month" style="padding-left: 0px; width: 50px;">
                  <option v-for="(item,index) in months" :value="item">{{item}}</option>
                </select>
              </div>
              <div class="col-sm-8">
                <select class="form-control" v-model="filters.year" style="padding-left: 0px;">
                  <option v-for="(item,index) in years" :value="item">{{item}}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="divReportFilter" v-show="report && report.Filters && report.Filters.FromDate && !report.Filters.Monthly">
            <span>From Date:</span>
            <input type="date" class="form-control" v-model="filters.fromDate" placeholder="Enter MAC Address" />
          </div>
          <div class="divReportFilter" v-show="report && report.Filters && report.Filters.ToDate && !report.Filters.Monthly">
            <span>To Date:</span>
            <input type="date" class="form-control" v-model="filters.toDate" min="filters.fromDate" placeholder="Enter MAC Address" />
          </div>
          <div class="divReportFilter" v-show="report && report.Filters && report.Filters.DateRange">
            <div class="row">
              <span class="col-sm-12">From Date:</span>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <select class="form-control" v-model="filters.fromMonth" style="padding-left: 0px; width: 50px; float: left;">
                  <option v-for="(item,index) in months" :value="item">{{item}}</option>
                </select>
                <span style="float: left; font-size: 20px; padding: 5px;">/</span>
                <select class="form-control" v-model="filters.fromYear" style="padding-left: 0px; width: 80px; float: left;">
                  <option v-for="(item,index) in years" :value="item">{{item}}</option>
                </select>
              </div>
            </div>
            <div class="row">
              <span class="col-sm-12">To Date:</span>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <select class="form-control" v-model="filters.toMonth" style="padding-left: 0px; width: 50px; float: left;">
                  <option v-for="(item,index) in months" :value="item">{{item}}</option>
                </select>
                <span style="float: left; font-size: 20px; padding: 5px;">/</span>
                <select class="form-control" v-model="filters.toYear" style="padding-left: 0px; width: 80px; float: left;">
                  <option v-for="(item,index) in years" :value="item">{{item}}</option>
                </select>
              </div>
            </div>
          </div>
          <div v-show="hasReportHistory && isUsageReport" class="divReportFilter">
            <hr />
            <h5>Report History:</h5>
            <span>Generated: </span><br />
            <span style="color: red; float: right;">{{reportHistory.GenerateDate}}</span>
            <br />
            <span>Printed: </span>
            <br />
            <span style="color: red; float: right;">{{reportHistory.PrintDate}}</span>
            <br />
            <span>Exported: </span>
            <br />
            <span style="color: red; float: right;">{{reportHistory.ExportDate}}</span>
          </div>
          <input type="button" class="btn btn-success" value="Run Report" style="margin-top: 20px; width: 100%;" @click="runReport" />
        </div>
      </va-box>
    </column>
    <column class="col-lg-10">
      <div class="box box-info">
        <div class="box-header">
          <i class="fa fa-bar-chart"></i>
          <h3 class="box-title">{{report ? report.Name : ''}}</h3>
          <!-- tools box -->
          <div class="pull-right box-tools">
            <button v-if="$root.isAdmin" type="button" class="btn btn-sm" data-widget="collapse" title="Edit Report" @click="editReportAdmin">
              <i class="fa fa-edit" style="font-size: 18px;"></i>
            </button>
            <button v-if="$root.isAdmin" type="button" class="btn btn-sm" data-widget="collapse" title="Edit Report" @click="editReport">
              <i class="fa fa-paint-brush" style="font-size: 18px;"></i>
            </button>
            <button type="button" class="btn btn-sm" data-widget="collapse" title="Save as PDF" @click="exportPDF">
              <i class="fa fa-file-pdf-o" style="font-size: 18px;"></i>
            </button>
            <button type="button" class="btn btn-sm" data-widget="collapse" title="Save as CSV" @click="exportCSV">
              <i class="fa fa-file-excel-o" style="font-size: 18px;"></i>
            </button>
            <button type="button" class="btn btn-sm" data-widget="collapse" title="Print" @click="print">
              <i class="fa fa-print" style="font-size: 18px;"></i>
            </button>
          </div>
          <!-- /. tools -->
        </div>
        <div class="box-body">
          <div slot="content" style="min-height: 450px; height: 100%; background-color: #ccc; padding: 10px;">
            <loading :active.sync="isLoading" :is-full-page="isFullpage"></loading>
            <!--<div class="report-output-render" style="height: 550px; background-color: #fff;"></div>-->
            <!--<embed id="pdfReport" class="report-output" type="application/pdf" style="width: 100%; height: 550px; border:none;" />-->
            <iframe id="iframReport" v-show="hasData" type="application/pdf" class="report-output" style="width: 100%; height: 550px; border:none;"></iframe>
            <div v-show="!hasData">
              <h3>No Data To show!</h3>
              <h4>Please select a report from the list in the left panel !</h4>
              <h5 v-show="error" style="color: red;">{{error}}</h5>
            </div>
          </div>
        </div>
      </div>
    </column>
  </row>
</template>
<script>
  import { db } from '../firebase'
  import Loading from 'vue-loading-overlay'
  import VABox from '../widgets/VABox'
  import VAInputGroup from '../components/VAInputGroup'
  import ReportBasic from '../reports/ReportBasic'
  import ReportCharts from '../reports/ReportCharts'
  import timeData from '../reports/data/time-data.json'
  // import reportToners from '../reports/data/reportsToners.json'
  // import testReport from '../reports/data/TestPrintersUsage.json'
  // import rpt1 from '../reports/rptDetailedUsage.json'
  import { GetPrintersHistory } from '../plugins/printersHistory.js'
  import { GetDealersUsage } from '../plugins/dealersUsage.js'
  import { GetDetailedUsage } from '../plugins/detailedUsage.js'
  import * as reportsDal from '../plugins/reportsDalTest.js'
  export default {
    name: 'reports',
    components: {
      'loading': Loading,
      'va-box': VABox,
      'va-input-group': VAInputGroup,
      ReportBasic,
      ReportCharts
    },
    data () {
      return {
        fromDate: '',
        error: '',
        hasReportHistory: false,
        reportHistory: { GenerateDate: '', PrintDate: '', ExportDate: '' },
        activeReport: 'Please Select Report...',
        hasData: false,
        isFullpage: false,
        reportKey: '',
        report: null,
        reportFile: '',
        reportPDF: '',
        filters1: {
          dealerKey: '',
          customerKey: 'All',
          siteKey: 'All',
          printerKey: '',
          fromDate: '',
          toDate: '',
          month: '',
          year: '',
          fromMonth: '',
          fromYear: '',
          toMonth: '',
          toYear: ''
        },
        filters: {
          dealerKey: 'UbMCpyGScbhRkNzuEvdf8uUqMgi2',
          customerKey: '-LugPOfAonDVzJ1Xeqrf',
          siteKey: '-LugPP8Vc7xv9SPXO192',
          printerKey: '',
          fromDate: '',
          toDate: '',
          month: '',
          year: '',
          fromMonth: '',
          fromYear: '',
          toMonth: '',
          toYear: ''
        },
        customers: [],
        sites: [],
        months: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
        years: [],
        isLoading: false,
        reportData: [],
        isTest: true,
        reports: [],
        dbReports: [],
        rptDetailedUsage: {},
        rptAccouting: {}
      }
    },
    firebase: function () {
      // var vm = this
      let reportsPath = 'Reports'
      reportsPath = 'FastReports'
      let reportsRef = db.ref(reportsPath)
      return {
        dbReports: reportsRef.orderByChild('OrderIndex')
      }
    },
    created () {
      // console.log(ReportsApp)
      this.$root.title = 'Reports'
      let toYear = Number(this.$moment().format('YYYY'))
      let fromYear = Number(this.$moment().add(-1, 'years').format('YYYY'))
      fromYear = 2021
      for (let y = toYear; y >= fromYear; y--) {
        this.years.push(y)
      }
      if (this.$root.isAdmin) {
        this.filters.dealerKey = ''
      } else if (this.$root.isDealer) {
        this.filters.dealerKey = this.$root.user['.key']
      } else if (this.$root.isCustomer) {
        console.log('Reports: created()')
        console.log('this.$root.isCustomer = ' + this.$root.isCustomer)
        console.log('$root.filter.customerKey = ' + this.$root.filter.customerKey)
        console.log(this.$root.filter)
        this.filters.dealerKey = this.$root.filter.dealerKey
        this.filters.customerKey = this.$root.filter.customerKey
        console.log('filters.customerKey = ' + this.filters.customerKey)
        console.log(this.filters)
      }
      /*
      if (this.$root.userHistory && this.$root.userHistory.fromDate && this.$root.userHistory.toDate) {
        this.filters.fromDate = this.$root.userHistory.fromDate
        this.filters.toDate = this.$root.userHistory.toDate
        this.filters.month = this.$moment(this.filters.fromDate, 'YYYY-MM-DD').format('MM')
        this.filters.year = this.$moment(this.filters.fromDate, 'YYYY-MM-DD').format('YYYY')
      } else {
        this.filters.fromDate = this.$moment().add(-7, 'days').format('YYYY-MM-DD')
        this.filters.toDate = this.$moment().format('YYYY-MM-DD')
        this.filters.month = this.$moment().format('MM')
        this.filters.year = this.$moment().format('YYYY')
      }
      */
      this.filters.fromDate = this.$moment().add(-7, 'days').format('YYYY-MM-DD')
      this.filters.toDate = this.$moment().format('YYYY-MM-DD')
      this.filters.month = this.$moment().format('MM')
      this.filters.year = this.$moment().format('YYYY')
      this.filters.fromMonth = this.$moment().format('MM')
      this.filters.fromYear = this.$moment().format('YYYY')
      this.filters.toMonth = this.$moment().format('MM')
      this.filters.toYear = this.$moment().format('YYYY')
    },
    mounted () {
      console.log('Total reports: ' + this.reports.length)
      this.rptDetailedUsage = this.initRptDetailedUsage()
      this.reports.push(this.rptDetailedUsage)
      if (this.$root.isAdmin) {
        this.rptAccouting = this.initRptAccounting()
        this.reports.push(this.rptAccouting)
      }
      console.log('Total dbReports: ' + this.dbReports.length)
    },
    computed: {
      totalDbReports () {
        if (this.dbReports) {
          return this.dbReports.length
        } else {
          return 0
        }
      },
      fromDateInt () {
        return Number(this.$moment(this.filters.fromDate).format('YYYYMMDD') + '0000')
      },
      toDateInt () {
        return Number(this.$moment(this.filters.toDate).format('YYYYMMDD') + '2359')
      },
      selectedMonth () {
        if (this.filters.month && this.filters.year) {
          return this.filters.month + '/' + this.filters.year
        } else {
          return ''
        }
      },
      selectedFromMonth () {
        if (this.filters.fromMonth && this.filters.fromYear) {
          return this.filters.fromMonth + '/' + this.filters.fromYear
        } else {
          return ''
        }
      },
      selectedToMonth () {
        if (this.filters.toMonth && this.filters.toYear) {
          return this.filters.toMonth + '/' + this.filters.toYear
        } else {
          return ''
        }
      },
      reportHistoryPath () {
        return 'ReportsHistory/' + this.filters.dealerKey + '_' + this.filters.customerKey + '_' + this.filters.siteKey + '_' + this.filters.year + this.filters.month
      },
      isUsageReport () {
        return (this.report && (this.report.Name === 'Printers Usage' || this.report.Name === 'Printers Details Usage'))
      },
      sortedDelaers () {
        let vm = this
        return vm.$root.dealers.sort(vm.compareItems)
      }
    },
    watch: {
      dbReports (val) {
        if (val && val.length > 0) {
          for (var r = 0; r < val.length; r++) {
            // this.reports.push(this.dbReports[r])
          }
        }
      },
      reportKey (val) {
        this.loadReport()
      },
      'filters.dealerKey' (val) {
        console.log('watch: filters.dealerKey = ' + val)
        if (!this.$root.isCustomer) {
          this.filters.customerKey = ''
          if (val === '') {
            this.customers = []
          } else {
            this.loadCustomers(val)
          }
        } else {
          this.customers = []
        }
      },
      'filters.customerKey' (val) {
        console.log('watch: filters.customerKey = ' + val)
        this.filters.siteKey = 'All'
        if (val === 'All') {
          this.sites = []
        } else {
          this.loadSites(val)
        }
      },
      'filters.siteKey' (val) {
        console.log('watch: filters.siteKey = ' + val)
      },
      'filters.fromDate' (val) {
        console.log('watch: filters.fromDate = ' + val)
        this.$root.userHistory.fromDate = val
        this.$root.setUserHistory()
      },
      'filters.toDate' (val) {
        console.log('watch: filters.toDate = ' + val)
        this.$root.userHistory.toDate = val
        this.$root.setUserHistory()
      },
      selectedMonth (val) {
        console.log('watch: selectedMonth = ' + val)
        if (val) {
          this.filters.fromDate = this.$moment([this.filters.year, this.filters.month - 1]).format('YYYY-MM-DD')
          this.filters.toDate = this.$moment(this.filters.fromDate).endOf('month').format('YYYY-MM-DD')
          // this.checkReportHistory()
        }
      },
      reportHistoryPath (val) {
        console.log(val)
        this.checkReportHistory()
      }
    },
    methods: {
      test () {
        reportsDal.Test()
      },
      isRTL (txt) {
        let ltrChars = 'A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02B8\u0300-\u0590\u0800-\u1FFF' + '\u2C00-\uFB1C\uFDFE-\uFE6F\uFEFD-\uFFFF'
        let rtlChars = '\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC'
        let rtlDirCheck = new RegExp('^[^' + ltrChars + ']*[' + rtlChars + ']')

        return rtlDirCheck.test(txt)
      },
      initRptAccounting () {
        let rptAccouting = {
          Definition: {
            body: {
              column_count: 1,
              data_source: 'report',
              elements: [
                {
                  height: 0.25,
                  left: 0,
                  text: '[DealerName]',
                  top: 0.05,
                  type: 'text',
                  width: 2
                },
                {
                  height: 0.25,
                  left: 2,
                  text: '[DealerEmail]',
                  top: 0,
                  type: 'text',
                  width: 2.5
                },
                {
                  height: 0.25,
                  left: 4.5,
                  text: '[Logged]',
                  top: 0,
                  type: 'text',
                  width: 1.5
                },
                {
                  height: 0.25,
                  left: 7,
                  text: '[LanPrinters]',
                  top: 0,
                  type: 'text',
                  width: 1
                },
                {
                  height: 0.25,
                  left: 6,
                  text: '[UsbPrinters]',
                  top: 0,
                  type: 'text',
                  width: 1
                },
                {
                  height: 0.25,
                  left: 8,
                  text: '[TotalPrinter]',
                  top: 0,
                  type: 'text',
                  width: 1
                },
                {
                  bold: true,
                  height: 0.25,
                  left: 9,
                  text: '[TotalReadPrinters]',
                  top: 0,
                  type: 'text',
                  width: 1
                }
              ]
            },
            default_format: 'html',
            filters: [],
            footer: {
              elements: [],
              height: 0,
              visible: false
            },
            header: {
              elements: [
                {
                  background_color: '#367FA9',
                  border_color: '#ffffff',
                  corner_radius: 0,
                  fontsize: 16,
                  height: 0.8,
                  id: 'box0',
                  left: 0,
                  styles: 'title',
                  text: 'BOX',
                  top: 0,
                  type: 'box',
                  width: 10,
                  wrap: true
                },
                {
                  bold: true,
                  fontsize: '20',
                  height: 0.5,
                  left: 0.1,
                  styles: 'title',
                  text: 'Monthly Dealers Usage',
                  text_color: '#ffffff',
                  top: 0.2,
                  type: 'text',
                  width: 3,
                  wrap: true
                },
                {
                  bold: true,
                  fontsize: '16',
                  height: 0.5,
                  left: 3.1,
                  styles: 'title',
                  text: '#Month#',
                  text_color: '#ffffff',
                  top: 0.25,
                  type: 'text',
                  width: 2,
                  wrap: true
                },
                {
                  bold: true,
                  fontsize: '14',
                  height: 0.5,
                  left: 7.5,
                  align: 'right',
                  styles: 'title',
                  text: '#Date#',
                  text_color: '#ffffff',
                  top: 0.2,
                  type: 'text',
                  width: 2,
                  wrap: true
                },
                {
                  bold: true,
                  height: 0.25,
                  left: 0,
                  text: 'Dealer Name',
                  top: 0.8,
                  type: 'text',
                  width: 2
                },
                {
                  bold: true,
                  height: 0.25,
                  left: 2,
                  text: 'Dealer Email',
                  top: 0.8,
                  type: 'text',
                  width: 2.5
                },
                {
                  bold: true,
                  height: 0.25,
                  left: 4.5,
                  text: 'Last Read',
                  top: 0.8,
                  type: 'text',
                  width: 1.5
                },
                {
                  bold: true,
                  height: 0.25,
                  left: 7,
                  text: 'Lan Printers',
                  top: 0.8,
                  type: 'text',
                  width: 1
                },
                {
                  bold: true,
                  height: 0.25,
                  left: 6,
                  text: 'Usb Printers',
                  top: 0.8,
                  type: 'text',
                  width: 1
                },
                {
                  bold: true,
                  height: 0.25,
                  left: 8,
                  text: 'Total Printers',
                  top: 0.8,
                  type: 'text',
                  width: 1
                },
                {
                  bold: true,
                  height: 0.25,
                  left: 9,
                  text: 'Total Reads',
                  top: 0.8,
                  type: 'text',
                  width: 1
                }
              ],
              height: 1.15
            },
            id: 'rptAccouting',
            inputs: [],
            page: {
              margins: {
                bottom: 0.5,
                left: 0.5,
                right: 0.5,
                top: 0.5
              },
              paper_size: {
                id: 'letter',
                inches: [11, 8.5],
                mm: [279, 216],
                name: 'Letter'
              },
              units: 'inches'
            },
            page_footer: {
              elements: [],
              height: 0,
              visible: false
            },
            page_header: {
              elements: [],
              height: 0,
              visible: false
            },
            title: 'Printers Toner Usage',
            type: 'hierarchical',
            version: '1.2.20'
          },
          Filters: {
            CustomerKey: false,
            DealerKey: false,
            FromDate: false,
            PrinterKey: false,
            SiteKey: false,
            ToDate: false,
            Monthly: true
          },
          Method: 'GetDealersUsage',
          Name: 'Dealers Usage',
          OrderIndex: 1000
        }
        rptAccouting['.key'] = 'rptAccounting'
        return rptAccouting
      },
      initRptDetailedUsage () {
        let rptDetailedUsage = {
          Definition: {
            body: {
              column_count: 1,
              data_source: 'report',
              elements: [
                {
                  height: 0.25,
                  left: 0,
                  text: '[Customer]',
                  top: 0,
                  type: 'text',
                  width: 1
                },
                {
                  height: 0.25,
                  left: 1,
                  text: '[Site]',
                  top: 0,
                  type: 'text',
                  width: 1
                },
                {
                  height: 0.25,
                  left: 2,
                  text: '[PrinterModel]',
                  top: 0,
                  type: 'text',
                  width: 1
                },
                {
                  height: 0.25,
                  left: 3,
                  text: '[IPAddress]',
                  top: 0,
                  type: 'text',
                  width: 1
                },
                {
                  height: 0.25,
                  left: 4,
                  text: '[PrinterSerial]',
                  top: 0,
                  type: 'text',
                  width: 1
                },
                {
                  height: 0.25,
                  left: 5,
                  text: '[StartDate]',
                  top: 0,
                  type: 'text',
                  width: 1
                },
                {
                  height: 0.25,
                  left: 6,
                  text: '[StartCount]',
                  top: 0,
                  type: 'text',
                  width: 1
                },
                {
                  height: 0.25,
                  left: 7,
                  text: '[EndDate]',
                  top: 0,
                  type: 'text',
                  width: 1
                },
                {
                  height: 0.25,
                  left: 8,
                  text: '[EndCount]',
                  top: 0,
                  type: 'text',
                  width: 1
                },
                {
                  bold: true,
                  height: 0.25,
                  left: 9,
                  text: '[PageCount]',
                  top: 0,
                  type: 'text',
                  width: 1
                }
              ]
            },
            default_format: 'html',
            filters: [],
            footer: {
              elements: [],
              height: 0,
              visible: false
            },
            header: {
              elements: [
                {
                  background_color: '#367FA9',
                  border_color: '#ffffff',
                  corner_radius: 0,
                  fontsize: 16,
                  height: 0.8,
                  id: 'box0',
                  left: 0,
                  styles: 'title',
                  text: 'BOX',
                  top: 0,
                  type: 'box',
                  width: 10,
                  wrap: true
                },
                {
                  bold: true,
                  fontsize: '20',
                  height: 0.5,
                  left: 0.1,
                  styles: 'title',
                  text: 'Printers Detailed Usage',
                  text_color: '#ffffff',
                  top: 0.2,
                  type: 'text',
                  width: 3,
                  wrap: true
                },
                {
                  bold: true,
                  fontsize: '16',
                  height: 0.5,
                  left: 7.5,
                  styles: 'title',
                  text: '#Month#',
                  text_color: '#ffffff',
                  top: 0.25,
                  type: 'text',
                  width: 2,
                  wrap: true
                },
                {
                  bold: true,
                  fontsize: '14',
                  height: 0.5,
                  left: 7.5,
                  align: 'right',
                  styles: 'title',
                  text: '#Date#',
                  text_color: '#ffffff',
                  top: 0.2,
                  type: 'text',
                  width: 2,
                  wrap: true
                },
                {
                  bold: true,
                  height: 0.25,
                  left: 0,
                  text: 'Customer',
                  top: 0.8,
                  type: 'text',
                  width: 1
                },
                {
                  bold: true,
                  height: 0.25,
                  left: 1,
                  text: 'Site',
                  top: 0.8,
                  type: 'text',
                  width: 1.5
                },
                {
                  bold: true,
                  height: 0.25,
                  left: 2,
                  text: 'Model',
                  top: 0.8,
                  type: 'text',
                  width: 1.5
                },
                {
                  bold: true,
                  height: 0.25,
                  left: 3,
                  text: 'IPAddress',
                  top: 0.8,
                  type: 'text',
                  width: 1
                },
                {
                  bold: true,
                  height: 0.25,
                  left: 4,
                  text: 'Serial',
                  top: 0.8,
                  type: 'text',
                  width: 1
                },
                {
                  bold: true,
                  height: 0.25,
                  left: 5,
                  text: 'Start Reading Date',
                  top: 0.8,
                  type: 'text',
                  width: 1
                },
                {
                  bold: true,
                  height: 0.25,
                  left: 6,
                  text: 'Start Meter Reading',
                  top: 0.8,
                  type: 'text',
                  width: 1
                },
                {
                  bold: true,
                  height: 0.25,
                  left: 7,
                  text: 'End Reading Date',
                  top: 0.8,
                  type: 'text',
                  width: 1
                },
                {
                  bold: true,
                  height: 0.25,
                  left: 8,
                  text: 'End Meter Reading',
                  top: 0.8,
                  type: 'text',
                  width: 1
                },
                {
                  bold: true,
                  height: 0.25,
                  left: 9,
                  text: 'Total Page Count',
                  top: 0.8,
                  type: 'text',
                  width: 1
                }
              ],
              height: 1.15
            },
            id: 'rptDetailedUsage',
            inputs: [],
            page: {
              margins: {
                bottom: 0.5,
                left: 0.5,
                right: 0.5,
                top: 0.5
              },
              paper_size: {
                id: 'letter',
                inches: [11, 8.5],
                mm: [279, 216],
                name: 'Letter'
              },
              units: 'inches'
            },
            page_footer: {
              elements: [],
              height: 0,
              visible: false
            },
            page_header: {
              elements: [],
              height: 0,
              visible: false
            },
            title: 'Printers Details Usage',
            type: 'hierarchical',
            version: '1.2.20'
          },
          Filters: {
            CustomerKey: true,
            DealerKey: true,
            FromDate: false,
            PrinterKey: false,
            SiteKey: true,
            ToDate: false,
            Monthly: false,
            DateRange: true
          },
          Method: 'GetDetailedUsage',
          Name: 'Printers Details Usage',
          OrderIndex: 0
        }
        rptDetailedUsage['.key'] = 'rptDetailedUsage'
        return rptDetailedUsage
      },
      compareItems (a, b) {
        try {
          const nameA = a.title.toUpperCase()
          const nameB = b.title.toUpperCase()
          if (nameA < nameB) return -1
          if (nameA > nameB) return 1
          return 0
        } catch (e) {
          return 0
        }
      },
      checkReportHistory () {
        let vm = this
        console.log('checkReportHistory()...')
        console.log('vm.reportHistoryPath = ' + vm.reportHistoryPath)
        db.ref(vm.reportHistoryPath).orderByKey().once('value', (snapReportHistory) => {
          const reportHistory = snapReportHistory.val()
          if (reportHistory) {
            console.log(reportHistory)
            vm.hasReportHistory = true
            vm.reportHistory = {
              GenerateDate: reportHistory.GenerateDate,
              PrintDate: reportHistory.PrintDate,
              ExportDate: reportHistory.ExportDate
            }
          } else {
            vm.hasReportHistory = false
          }
        })
        /*
        this.hasReportHistory = true
        this.reportHistory = { GenerateDate: '05/06/2019', PrintDate: '', ExportDate: '' }
        */
      },
      editReportAdmin () {
        console.log('editReportAdmin()...')
        let vm = this
        vm.$root.goto('ReportEditor')
      },
      editReport () {
        console.log('editReport()...')
        let vm = this
        if (vm.reportKey) {
          vm.$router.push({ name: 'ReportDesigner', params: { reportKey: vm.reportKey } })
        } else {
          vm.$root.goto('ReportDesigner')
        }
      },
      editReportOLD () {
        var dataSource = [{
          id: 'time',
          name: 'Time',
          data: timeData,
          schema: this.report.Schema
        }]
        // Initialize a designer to modify the report definition
        var designer = new jsreports.Designer({
          data_sources: dataSource,
          images: [{
            name: 'ACME logo',
            url: 'images/acme-logo.png'
          }],
          report_def: this.report.Definition
        })

        console.log(designer)
      },
      loadReport () {
        console.log('loadReport()...')
        let vm = this
        vm.error = ''
        vm.report = null
        vm.filters.printerKey = ''
        try {
          $('.report-output').attr('src', '')
          if (vm.isTest === false) {
            vm.report = testReport
            vm.report = vm.validateReport(vm.report)
          } else {
            for (let i = 0; i < vm.reports.length; i++) {
              if (vm.reports[i]['.key'] === vm.reportKey) {
                vm.report = vm.reports[i]
                vm.report = vm.validateReport(vm.report)
                break
              }
            }
          }
        } catch (e) {
          vm.hasData = false
          vm.error = e.message
        }
      },
      runReport () {
        let vm = this
        console.log('runReport()...')
        console.log('runReport() >>> vm.filters.dealerKey = ' + vm.filters.dealerKey)
        vm.isLoading = true
        try {
          if (vm.report) {
            let childKey = ''
            let startAtValue = vm.fromDateInt
            let endAtValue = vm.toDateInt
            vm.filters.printerKey = vm.filters.printerKey.toUpperCase().trim()
            if (vm.$root.isDealer) {
              vm.filters.dealerKey = vm.$root.user['.key']
            }
            if (vm.filters.dealerKey === 'All' || !vm.report.Filters.DealerKey) {
              if (vm.filters.printerKey === '') {
                childKey = 'LoggedInt'
                startAtValue = vm.fromDateInt
                endAtValue = vm.toDateInt
              } else {
                childKey = 'DateMacKey'
                startAtValue = vm.filters.printerKey + '_' + vm.fromDateInt
                endAtValue = vm.filters.printerKey + '_' + vm.toDateInt
              }
            } else {
              if (vm.filters.customerKey === 'All') {
                console.log('runReport: vm.filters.customerKey = All')
                if (vm.filters.printerKey === '') {
                  childKey = 'DateDealerKey'
                  startAtValue = vm.filters.dealerKey + '_' + vm.fromDateInt
                  endAtValue = vm.filters.dealerKey + '_' + vm.toDateInt
                } else {
                  childKey = 'DateDealerMacKey'
                  startAtValue = vm.filters.dealerKey + '_' + vm.filters.printerKey + '_' + vm.fromDateInt
                  endAtValue = vm.filters.dealerKey + '_' + vm.filters.printerKey + '_' + vm.toDateInt
                }
              } else {
                if (vm.filters.siteKey === 'All') {
                  console.log('runReport: vm.filters.siteKey = All')
                  console.log('vm.filters.dealerKey = ' + vm.filters.dealerKey)
                  console.log('vm.filters.customerKey = ' + vm.filters.customerKey)
                  if (vm.filters.printerKey === '') {
                    childKey = 'DateDealerCustomerKey'
                    startAtValue = vm.filters.dealerKey + '_' + vm.filters.customerKey + '_' + vm.fromDateInt
                    endAtValue = vm.filters.dealerKey + '_' + vm.filters.customerKey + '_' + vm.toDateInt
                    console.log('DateDealerCustomerKey startAtValue = ' + startAtValue)
                    console.log('DateDealerCustomerKey endAtValue = ' + endAtValue)
                  } else {
                    childKey = 'DateDealerCustomerMacKey'
                    startAtValue = vm.filters.dealerKey + '_' + vm.filters.customerKey + '_' + vm.filters.printerKey + '_' + vm.fromDateInt
                    endAtValue = vm.filters.dealerKey + '_' + vm.filters.customerKey + '_' + vm.filters.printerKey + '_' + vm.toDateInt
                  }
                } else {
                  if (vm.filters.printerKey === '') {
                    childKey = 'DateDealerCustomerSiteKey'
                    startAtValue = vm.filters.dealerKey + '_' + vm.filters.customerKey + '_' + vm.filters.siteKey + '_' + vm.fromDateInt
                    endAtValue = vm.filters.dealerKey + '_' + vm.filters.customerKey + '_' + vm.filters.siteKey + '_' + vm.toDateInt
                  } else {
                    childKey = 'DateDealerCustomerSiteMacKey'
                    startAtValue = vm.filters.dealerKey + '_' + vm.filters.customerKey + '_' + vm.filters.siteKey + '_' + vm.filters.printerKey + '_' + vm.fromDateInt
                    endAtValue = vm.filters.dealerKey + '_' + vm.filters.customerKey + '_' + vm.filters.siteKey + '_' + vm.filters.printerKey + '_' + vm.toDateInt
                  }
                }
              }
            }
            // DateMacKey
            // DealerCustomerSiteMacKey
            // DateDealerCustomerSiteMacKey
            console.log(childKey)
            console.log(startAtValue)
            console.log(endAtValue)

            if (!vm.report.Definition.filters) {
              vm.report.Definition.filters = []
            }
            if (!vm.report.Definition.inputs) {
              vm.report.Definition.inputs = []
            }
            vm.report.Definition.page.paper_size.inches = [8.5, 11]
            vm.report.Definition.page.paper_size.mm = [216, 279]

            vm.report.Definition.page.paper_size.inches = [11, 8.5]
            vm.report.Definition.page.paper_size.mm = [279, 216]
            // vm.report.Definition.page_footer.elements[0] = {}

            // console.log(printersHistory)
            // Set Report Date
            for (let i = 0; i < vm.report.Definition.header.elements.length; i++) {
              if (vm.report.Definition.header.elements[i].text === 'Date') {
                // vm.report.Definition.header.elements[i].text = vm.$moment().format('DD/MM/YYYY')
                // vm.report.Definition.header.elements[i].text = 'تاريخ التقرير' // Test Lang Ar
                // vm.report.Definition.header.elements[i].text = 'תאריך הדוח' // Test Lang He
                // vm.report.Definition.header.elements[i].text = 'Report Date' // Test Lang En
              }
              if (vm.report.Definition.header.elements[i].text === '#Date#') {
                vm.report.Definition.header.elements[i].text = vm.$moment().format('DD/MM/YYYY')
              }
              if (vm.report.Definition.header.elements[i].text === '#Month#') {
                console.log('vm.report.Definition.header.elements[' + i + '].text = ' + vm.report.Definition.header.elements[i].text)
                if (vm.report.Method !== 'GetDetailedUsage') {
                  vm.report.Definition.header.elements[i].text = 'Month: ' + vm.selectedMonth
                }
                vm.$forceUpdate()
              }
            }

            if (vm.report.Method === 'GetErrorsByMac') {
              if (vm.filters.printerKey === '') {
                vm.isLoading = false
                vm.hasData = false
                vm.error = 'Please enter MAC Address!'
                return
              }
            }
            if (vm.report.Method === 'GetDealersUsage') {
              GetDealersUsage(vm, startAtValue, endAtValue)
            } else {
              let fromDateStr = vm.fromDateInt + ''
              let toDateStr = vm.toDateInt + ''
              let historyFilters = {
                fromDate: fromDateStr,
                toDate: toDateStr,
                dealer: vm.filters.dealerKey,
                // customers: customersList,
                // customers: [vm.filters.customerKey],
                customers: [],
                sites: [],
                // datePaths: [vm.filters.year + '/' + vm.filters.month + '/'],
                datePaths: [],
                fromMonth: vm.filters.fromMonth,
                fromYear: vm.filters.fromYear,
                toMonth: vm.filters.toMonth,
                toYear: vm.filters.toYear
              }

              if (vm.filters.month === '01') {
                let prevYear = Number(vm.filters.year) - 1
                historyFilters.datePaths.push(prevYear + '/12/')
              } else {
                let prevMonth = Number(vm.filters.month) - 1
                if (prevMonth < 10) {
                  prevMonth = '0' + prevMonth
                }
                historyFilters.datePaths.push(vm.filters.year + '/' + prevMonth + '/')
              }
              historyFilters.datePaths.push(vm.filters.year + '/' + vm.filters.month + '/')
              // customerKey
              let customerName = 'Unknown'
              let siteName = 'Unknown'
              // let customersList = []
              // let sitesList = []
              if (vm.filters.customerKey === 'All') {
                vm.filters.siteKey = 'All'
                customerName = 'All Customers'
                siteName = 'All Sites'
                if (vm.filters.dealerKey === 'All') {
                  historyFilters.customers = vm.$root.customers
                  historyFilters.sites = vm.$root.sites
                } else {
                  for (let c = 0; c < vm.$root.customers.length; c++) {
                    if (vm.$root.customers[c].dealerKey === vm.filters.dealerKey) {
                      historyFilters.customers.push(vm.$root.customers[c])
                      for (let s = 0; s < vm.$root.sites.length; s++) {
                        if (vm.$root.sites[s].customerKey === vm.$root.customers[c].value) {
                          historyFilters.sites.push(vm.$root.sites[s])
                        }
                      }
                    }
                  }
                }
              } else {
                for (let c = 0; c < vm.$root.customers.length; c++) {
                  if (vm.$root.customers[c].value === vm.filters.customerKey) {
                    // customerName = vm.$root.customers[c].title
                    historyFilters.customers.push(vm.$root.customers[c])
                    if (vm.filters.siteKey === 'All') {
                      siteName = 'All Sites'
                      for (let s = 0; s < vm.$root.sites.length; s++) {
                        if (vm.$root.sites[s].customerKey === vm.$root.customers[c].value) {
                          historyFilters.sites.push(vm.$root.sites[s])
                        }
                      }
                    } else {
                      for (let s = 0; s < vm.$root.sites.length; s++) {
                        if (vm.$root.sites[s].value === vm.filters.siteKey) {
                          siteName = vm.$root.sites[s].title
                          historyFilters.sites.push(vm.$root.sites[s])
                          break
                        }
                      }
                    }
                    break
                  }
                }
              }
              if (vm.report.Definition.header.elements[3].text === '#Customer #Site') {
                vm.report.Definition.header.elements[3].text = '  Customer: ' + customerName + ' / Site: ' + siteName + ''
              } else {
                vm.report.Definition.header.elements[3].text = ''
              }
              console.log(JSON.stringify(vm.report.Definition.header))
              // CONNECT TO NEW DATABASE : DB_STORE
              let printersHistory = []
              // console.log(JSON.stringify(historyFilters))
              // console.log(historyFilters)
              if (vm.report.Method === 'GetDetailedUsage') {
                GetDetailedUsage(vm, historyFilters).then(function (result) {
                  // GetDetailedUsage() selectedFromMonth = 2021/09
                  // detailedUsage.js?7fc8:13 GetDetailedUsage() selectedToMonth = 2021/10
                  if (result.Success) {
                    console.log('GetDetailedUsage result.Data = ' + result.Data.length)
                    if (result.Data.length > 0) {
                     // console.log(JSON.stringify(result.Data))
                      vm.reportData = result.Data
                      vm.exportDetailedUsageReport(vm, result.Data)
                    }
                  } else {
                    vm.hasData = false
                    vm.error = 'Report has no data!'
                    console.log('Report NO DATA !!')
                  }
                  vm.isLoading = false
                })
              } else {
                GetPrintersHistory(vm, historyFilters).then(function (result) {
                  console.log(result)
                  if (result.Success) {
                    printersHistory = result.Data
                    switch (vm.report.Method) {
                      // case 'GetDetailedUsage': vm.exportDetailedUsageReport(vm, printersHistory); break
                      case 'GetUsage': vm.exportUsageReport(vm, printersHistory); break
                      case 'GetCounters': vm.exportCountersReport(vm, printersHistory); break
                      case 'GetToners': vm.exportTonersReport(vm, printersHistory); break
                      case 'GetErrors': vm.exportErrorsReport(vm, printersHistory); break
                      case 'GetErrorsByMac': vm.exportErrorsByMacReport(vm, printersHistory); break
                      case 'GetStatus': vm.exportStatusReport(vm, printersHistory); break
                      // case 'GetDealersUsage': vm.exportDealersUsageReport(vm, printersHistory); break
                      default: vm.isLoading = false; vm.hasData = false; break
                    }
                  } else {
                    vm.isLoading = false
                    vm.hasData = false
                    vm.error = 'Report has no data!'
                    console.log('Report NO DATA !!')
                  }
                  vm.isLoading = false
                }).catch(function (error) {
                  console.log(error)
                  vm.isLoading = false
                })
              }
              /*
              db.ref('History').orderByChild(childKey).startAt(startAtValue).endAt(endAtValue).once('value', (snapPrintersHistory) => {
                let printersHistory = []
                const data = snapPrintersHistory.val()
                if (data) {
                  // console.log(data)
                  const pritnerKeys = Object.keys(data)
                  for (let i = 0; i < pritnerKeys.length; i++) {
                    let pKey = pritnerKeys[i]
                    let printer = data[pKey]
                    printer['.key'] = pKey
                    printersHistory.push(printer)
                  }
                  switch (vm.report.Method) {
                    case 'GetUsage': vm.exportUsageReport(vm, printersHistory); break
                    case 'GetCounters': vm.exportCountersReport(vm, printersHistory); break
                    case 'GetToners': vm.exportTonersReport(vm, printersHistory); break
                    case 'GetErrors': vm.exportErrorsReport(vm, printersHistory); break
                    case 'GetErrorsByMac': vm.exportErrorsByMacReport(vm, printersHistory); break
                    case 'GetStatus': vm.exportStatusReport(vm, printersHistory); break
                    default: vm.isLoading = false; vm.hasData = false; break
                  }
                } else {
                  vm.isLoading = false
                  vm.hasData = false
                  vm.error = 'Report has no data!'
                  console.log('Report NO DATA !!')
                }
              })
              */
            }
          } else {
            vm.isLoading = false
            vm.hasData = false
            vm.error = 'Failed to create report!!'
          }
        } catch (e) {
          vm.isLoading = false
          vm.hasData = false
          vm.error = e.message
        }
      },
      loadPrintersHistory () {
        console.log('loadPrintersHistory()...')
        const vm = this
        // vm.testFunc()
        vm.isLoading = true
        vm.$root.userHistory.selectedCustomer = vm.$route.params.customerKey
        vm.$root.userHistory.selectedSite = vm.$route.params.siteKey
        vm.$root.userHistory.fromDate = vm.filters.fromDate
        vm.$root.userHistory.toDate = vm.filters.toDate
        vm.$root.setUserHistory()

        let childKey = 'DateDealerKey'
        let startAtValue = vm.filters.dealerKey + '_' + vm.fromDateInt
        let endAtValue = vm.filters.dealerKey + '_' + vm.toDateInt
        if (vm.filters.customerKey === 'All') {
          childKey = 'DateDealerKey'
          startAtValue = vm.filters.dealerKey + '_' + vm.fromDateInt
          endAtValue = vm.filters.dealerKey + '_' + vm.toDateInt
        } else {
          if (vm.filters.siteKey === 'All') {
            childKey = 'DateDealerCustomerKey'
            startAtValue = vm.filters.dealerKey + '_' + vm.filters.customerKey + '_' + vm.fromDateInt
            endAtValue = vm.filters.dealerKey + '_' + vm.filters.customerKey + '_' + vm.toDateInt
          } else {
            childKey = 'DateDealerCustomerSiteKey'
            startAtValue = vm.filters.dealerKey + '_' + vm.filters.customerKey + '_' + vm.filters.siteKey + '_' + vm.fromDateInt
            endAtValue = vm.filters.dealerKey + '_' + vm.filters.customerKey + '_' + vm.filters.siteKey + '_' + vm.toDateInt
          }
        }
        console.log(childKey)
        console.log(startAtValue)
        console.log(endAtValue)
        let fromDate = {
          Year: Number(vm.$moment(vm.filters.fromDate).format('YYYY')),
          Month: Number(vm.$moment(vm.filters.fromDate).format('MM')),
          Day: Number(vm.$moment(vm.filters.fromDate).format('DD')),
          Path: ''
        }
        let toDate = {
          Year: Number(vm.$moment(vm.filters.toDate).format('YYYY')),
          Month: Number(vm.$moment(vm.filters.toDate).format('MM')),
          Day: Number(vm.$moment(vm.filters.toDate).format('DD')),
          Path: ''
        }
        fromDate.Path = vm.$moment(vm.filters.fromDate).format('YYYY') + '/' + vm.$moment(vm.filters.fromDate).format('MM') + '/'
        toDate.Path = vm.$moment(vm.filters.toDate).format('YYYY') + '/' + vm.$moment(vm.filters.toDate).format('MM') + '/'
        let diffDate = {
          Year: toDate.Year - fromDate.Year,
          Month: toDate.Month - fromDate.Month,
          Day: toDate.Day - fromDate.Day
        }
        var startDateString = vm.filters.fromDate
        var endDateString = vm.filters.toDate
        var startDate = vm.$moment(startDateString, 'YYYY-MM-DD')
        var endDate = vm.$moment(endDateString, 'YYYY-MM-DD').endOf('month')
        var datesPathList = []
        while (startDate.isBefore(endDate)) {
          datesPathList.push(startDate.format('YYYY/MM/'))
          startDate = startDate.add(1, 'month')
        }
        console.log(diffDate)
        // console.log('Call GetSubCollections() ... ')
        // let docPath = '/PrintersHistory/Dealers/' + vm.filters.dealerKey + '/Customers'
        // const getSubCollections = func.httpsCallable('GetSubCollections')
        vm.printersHistory = []
        let fromDateStr = vm.fromDateInt + ''
        let toDateStr = vm.toDateInt + ''
        let selectedCustomersKeys = []
        if (vm.filters.customerKey === 'All') {
          vm.customers.forEach(function (cust) {
            selectedCustomersKeys.push(cust.value)
          })
        } else {
          selectedCustomersKeys.push(vm.filters.customerKey)
        }
        let historyFilters = {
          fromDate: fromDateStr,
          toDate: toDateStr,
          dealer: vm.filters.dealerKey,
          customers: selectedCustomersKeys,
          datePaths: datesPathList
        }
        GetPrintersHistory(vm, historyFilters).then(function (result) {
          console.log(result)
          if (result.Success) {
            vm.printersHistory = result.Data
          }
          vm.isLoading = false
        }).catch(function (error) {
          console.log(error)
          vm.isLoading = false
        })
      },
      exportDetailedUsageReport (vm, dataArr) {
        console.log('exportDetailedUsageReport()...')
        console.log('dataArr.length = ' + dataArr.length)
        console.log('Sort dataArr ...')
        vm.exportReport(vm, dataArr)
      },
      exportDetailedUsageReport_OLD (vm, dataArr) {
        console.log('exportDetailedUsageReport()...')
        console.log('dataArr.length = ' + dataArr.length)
        if (vm.report.Filters.Monthly && vm.selectedMonth === '') {
          vm.isLoading = false
          vm.hasData = false
          vm.error = 'Please select Month and Year!'
          return
        }
        // Group By MAC
        let grpHistory = dataArr.reduce(function (r, a) {
          r[a.MacAddress] = r[a.MacAddress] || []
          r[a.MacAddress].push(a)
          return r
        }, Object.create(null))

        // console.log(grpHistory)
        vm.reportData = []

        if (grpHistory) {
          let keys = Object.keys(grpHistory)
          console.log('Object.keys(grpHistory) = ' + keys.length)
          for (let k = 0; k < keys.length; k++) {
            let key = keys[k]
            let printerArr = grpHistory[key]
            printerArr = printerArr.slice().sort(function (a, b) {
              return a.LoggedInt < b.LoggedInt ? -1 : 1
            })
            // console.log('console.log(printerArr)')
            console.log(printerArr)
            if (printerArr) {
              var firstItem = printerArr[0]
              var lastItem = printerArr[printerArr.length - 1]
              console.log('firstItem')
              console.log(firstItem)
              console.log('lastItem')
              console.log(lastItem)
              // for(let )
              vm.reportData.push(
                {
                  Dealer: lastItem.Dealer,
                  Customer: lastItem.Customer,
                  Site: lastItem.Site,
                  Address: 'Address',
                  PrinterModel: lastItem.ModelName,
                  IPAddress: lastItem.IPAddress,
                  PrinterSerial: lastItem.PrinterSerial,
                  StartDate0: firstItem.Logged,
                  StartDate: vm.$moment(firstItem.Logged, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY'),
                  StartCount: firstItem.PageCount,
                  EndDate0: lastItem.Logged,
                  EndDate: vm.$moment(lastItem.Logged, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY'),
                  EndCount: lastItem.PageCount,
                  PageCount: lastItem.PageCount - firstItem.PageCount >= 0 ? lastItem.PageCount - firstItem.PageCount : 'Error'
                }
              )
            }
          }
        }
        if (!vm.$root.isAdmin && vm.isUsageReport) {
          db.ref(vm.reportHistoryPath + '/ReportKey').set(vm.reportKey)
          db.ref(vm.reportHistoryPath + '/GenerateDate').set(vm.$moment().format('DD/MM/YYYY HH:mm'))
          db.ref(vm.reportHistoryPath + '/CustomerKey').set(vm.filters.customerKey)
          db.ref(vm.reportHistoryPath + '/SiteKey').set(vm.filters.siteKey)
          vm.checkReportHistory()
        }
        // console.log(JSON.stringify(vm.reportData))
        console.log('dataArr.length = ' + dataArr.length)
        console.log('vm.reportData.length = ' + vm.reportData.length)
        vm.exportReport(vm, vm.reportData)
      },
      exportUsageReport (vm, dataArr) {
        console.log('exportUsageReport()...')
        console.log('dataArr.length = ' + dataArr.length)
        if (vm.report.Filters.Monthly && vm.selectedMonth === '') {
          vm.isLoading = false
          vm.hasData = false
          vm.error = 'Please select Month and Year!'
          return
        }
        // Group By MAC
        let grpHistory = dataArr.reduce(function (r, a) {
          r[a.MacAddress] = r[a.MacAddress] || []
          r[a.MacAddress].push(a)
          return r
        }, Object.create(null))

        // console.log(grpHistory)
        vm.reportData = []

        if (grpHistory) {
          let keys = Object.keys(grpHistory)
          console.log('Object.keys(grpHistory) = ' + keys.length)
          for (let k = 0; k < keys.length; k++) {
            let key = keys[k]
            let printerArr = grpHistory[key]
            printerArr = printerArr.slice().sort(function (a, b) {
              return a.LoggedInt < b.LoggedInt ? -1 : 1
            })
            // console.log('console.log(printerArr)')
            // console.log(printerArr)
            if (printerArr) {
              var firstItem = printerArr[0]
              var lastItem = printerArr[printerArr.length - 1]
              console.log('firstItem')
              console.log(firstItem)
              console.log('lastItem')
              console.log(lastItem)
              // for(let )
              vm.reportData.push(
                {
                  Logged: lastItem.Logged,
                  MacAddress: key,
                  PrinterSerial: lastItem.PrinterSerial,
                  IPAddress: lastItem.IPAddress,
                  PageCount: lastItem.PageCount - firstItem.PageCount >= 0 ? lastItem.PageCount - firstItem.PageCount : 'Error',
                  A4Black: lastItem.A4Black - firstItem.A4Black >= 0 ? lastItem.A4Black - firstItem.A4Black : 'Error',
                  A4Color: lastItem.A4Color - firstItem.A4Color >= 0 ? lastItem.A4Color - firstItem.A4Color : 'Error',
                  A3Black: lastItem.A3Black - firstItem.A3Black >= 0 ? lastItem.A3Black - firstItem.A3Black : 'Error',
                  A3Color: lastItem.A3Color - firstItem.A3Color >= 0 ? lastItem.A3Color - firstItem.A3Color : 'Error'
                }
              )
            }
          }
        }
        if (!vm.$root.isAdmin && vm.isUsageReport) {
          db.ref(vm.reportHistoryPath + '/ReportKey').set(vm.reportKey)
          db.ref(vm.reportHistoryPath + '/GenerateDate').set(vm.$moment().format('DD/MM/YYYY HH:mm'))
          db.ref(vm.reportHistoryPath + '/CustomerKey').set(vm.filters.customerKey)
          db.ref(vm.reportHistoryPath + '/SiteKey').set(vm.filters.siteKey)
          vm.checkReportHistory()
        }
        // console.log(JSON.stringify(vm.reportData))
        console.log('dataArr.length = ' + dataArr.length)
        console.log('vm.reportData.length = ' + vm.reportData.length)
        vm.exportReport(vm, vm.reportData)
      },
      exportCountersReport (vm, dataArr) {
        console.log('exportCountersReport()...')
        if (vm.report.Filters.Monthly && vm.selectedMonth === '') {
          vm.isLoading = false
          vm.hasData = false
          vm.error = 'Please select Month and Year!'
          return
        }
        // Group By MAC
        let grpHistory = dataArr.reduce(function (r, a) {
          r[a.MacAddress] = r[a.MacAddress] || []
          r[a.MacAddress].push(a)
          return r
        }, Object.create(null))

        // console.log(grpHistory)
        vm.reportData = []

        if (grpHistory) {
          let keys = Object.keys(grpHistory)
          for (let k = 0; k < keys.length; k++) {
            let key = keys[k]
            let printerArr = grpHistory[key]
            printerArr = printerArr.slice().sort(function (a, b) {
              return a.LoggedInt < b.LoggedInt ? -1 : 1
            })
            // console.log('console.log(printerArr)')
            console.log(printerArr)
            if (printerArr) {
              var firstItem = printerArr[0]
              var lastItem = printerArr[printerArr.length - 1]

              console.log('firstItem')
              console.log(firstItem)
              console.log('lastItem')
              console.log(lastItem)
              // for(let )
              vm.reportData.push(
                {
                  Logged: lastItem.Logged,
                  MacAddress: key,
                  PrinterSerial: lastItem.PrinterSerial,
                  IPAddress: lastItem.IPAddress,
                  PageCount: lastItem.PageCount,
                  A4Black: lastItem.A4Black,
                  A4Color: lastItem.A4Color,
                  A3Black: lastItem.A3Black,
                  A3Color: lastItem.A3Color
                }
              )
            }
          }
        }
        vm.exportReport(vm, vm.reportData)
      },
      exportTonersReport (vm, dataArr) {
        console.log('exportTonersReport()...')
        // Group By MAC
        let grpHistory = dataArr.reduce(function (r, a) {
          r[a.MacAddress] = r[a.MacAddress] || []
          r[a.MacAddress].push(a)
          return r
        }, Object.create(null))

        // console.log(grpHistory)
        vm.reportData = []

        if (grpHistory) {
          let keys = Object.keys(grpHistory)
          for (let k = 0; k < keys.length; k++) {
            let key = keys[k]
            let printerArr = grpHistory[key]
            // console.log('console.log(printerArr)')
            // console.log(printerArr)
            if (printerArr) {
              // var firstItem = printerArr[0]
              var lastItem = printerArr[printerArr.length - 1]
              // for(let )
              vm.reportData.push(lastItem)
            }
          }
        }
        vm.exportReport(vm, vm.reportData)
      },
      exportErrorsReport (vm, dataArr) {
        console.log('exportErrorsReport()...')
        // Group By MAC
        let grpHistory = dataArr.reduce(function (r, a) {
          r[a.MacAddress] = r[a.MacAddress] || []
          r[a.MacAddress].push(a)
          return r
        }, Object.create(null))

        // console.log(grpHistory)
        vm.reportData = []

        if (grpHistory) {
          let keys = Object.keys(grpHistory)
          for (let k = 0; k < keys.length; k++) {
            let key = keys[k]
            let printerArr = grpHistory[key]
            // console.log('console.log(printerArr)')
            // console.log(printerArr)
            if (printerArr) {
              // var firstItem = printerArr[0]
              var lastItem = printerArr[printerArr.length - 1]
              // for(let )
              vm.reportData.push(lastItem)
            }
          }
        }
        vm.exportReport(vm, vm.reportData)
      },
      exportErrorsByMacReport (vm, dataArr) {
        console.log('exportErrorsByMacReport()...')
        vm.reportData = []
        vm.reportData = dataArr.sort((a, b) => (a.LoggedInt > b.LoggedInt) ? 1 : -1)
        vm.exportReport(vm, vm.reportData)
      },
      exportStatusReport (vm, dataArr) {
        console.log('exportStatusReport()...')
        vm.isLoading = false
        vm.hasData = false
        vm.error = 'Report Error: Failed to run report!'
      },
      renderReport (vm, reportData) {
        console.log('exportReport()...')
        let dataSource = [{
          id: 'report',
          data: reportData
        }]
        try {
          jsreports.render({
            report_def: vm.report.Definition,
            target: $('.report-output-render'),
            datasets: dataSource
          })

          vm.isLoading = false
          vm.hasData = true
        } catch (exp) {
          console.log('jsreports.export Error: ' + exp.message)
          vm.isLoading = false
          vm.hasData = false
          vm.error = 'Report Error: ' + exp.message
        }
      },
      exportReport (vm, reportData) {
        console.log('exportReport()...')
        let dataSource = [{
          id: 'report',
          data: reportData
        }]

        try {
          // vm.isLoading = false
          vm.hasData = true
          if (jsreports) {
            // console.log('jsreports: ' + jsreports)
            jsreports.export({
              format: 'pdf',
              report_def: vm.report.Definition,
              datasets: dataSource,
              outputHandler: function (pdfBlob) {
                vm.reportPDF = URL.createObjectURL(pdfBlob)
                $('.report-output').attr('src', URL.createObjectURL(pdfBlob))
                vm.isLoading = false
                vm.hasData = true
              }
            })
          } else {
            // location.reload()
            console.log('Report Error: [jsreports]')
            vm.isLoading = false
            vm.hasData = false
            vm.error = 'Report Error: [jsreports]'
          }
        } catch (exp) {
          console.log('jsreports.export Error: ' + exp.message)
          vm.isLoading = false
          vm.hasData = false
          vm.error = 'Report Error: ' + exp.message
        }
      },
      exportPDF () {
        let vm = this
        let dataSource = [{
          id: 'report',
          data: vm.reportData
        }]
        jsreports.export({
          format: 'pdf',
          report_def: vm.report.Definition,
          datasets: dataSource,
          outputHandler: function (pdfBlob) {
            const link = document.createElement('a')
            link.href = URL.createObjectURL(pdfBlob)
            link.download = vm.report.Name + '_From_' + vm.filters.fromDate + '_To_' + vm.filters.toDate + '.pdf'
            document.body.append(link)
            link.click()
            link.remove()
            window.addEventListener('focus', e => URL.revokeObjectURL(link.href), { once: true })
            if (!vm.$root.isAdmin && vm.isUsageReport) {
              db.ref(vm.reportHistoryPath + '/ExportDate').set(vm.$moment().format('DD/MM/YYYY HH:mm'))
              vm.checkReportHistory()
            }
          }
        })
      },
      exportCSV () {
        let vm = this
        let csv = vm.report.Name + '\n'
        let headers = []
        for (let i = 0; i < vm.report.Definition.body.elements.length; i++) {
          console.log(vm.report.Definition.body.elements[i].text)
          headers.push(vm.report.Definition.body.elements[i].text.replace('[', '').replace(']', ''))
        }
        csv += headers.join(',')
        csv += '\n'
        console.log(csv)
        vm.reportData.forEach(function (rowObj) {
          let row = []
          for (let i = 0; i < headers.length; i++) {
            row.push(rowObj[headers[i]])
          }
          csv += row.join(',')
          csv += '\n'
        })
        var hiddenElement = document.createElement('a')
        hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv)
        hiddenElement.target = '_blank'
        hiddenElement.download = vm.report.Name + '.csv'
        hiddenElement.click()
        if (!vm.$root.isAdmin && vm.isUsageReport) {
          db.ref(vm.reportHistoryPath + '/ExportDate').set(vm.$moment().format('DD/MM/YYYY HH:mm'))
          vm.checkReportHistory()
        }
      },
      print () {
        const vm = this
        document.getElementById('iframReport').contentWindow.print()
        if (!vm.$root.isAdmin && vm.isUsageReport) {
          db.ref(vm.reportHistoryPath + '/PrintDate').set(vm.$moment().format('DD/MM/YYYY HH:mm'))
          vm.checkReportHistory()
        }
      },
      loadCustomers (dealerKey) {
        console.log('loadCustomers...')
        const vm = this
        // const sitesPath = 'Dealers/' + vm.$root.user['.key'] + '/Customers/' + customerKey + '/Sites'
        // const sitesRef = db.ref(sitesPath)
        vm.customers = []
        vm.customers = vm.$root.customers.filter(function (item) {
          return item.dealerKey === dealerKey
        })

        vm.customers = vm.customers.sort(vm.compareItems)
        /*
        sitesRef.once('value').then(function (snapItems) {
          const data = snapItems.val()
          if (data) {
            console.log(data)
            const keys = Object.keys(data)
            // vm.sites = data
            for (let i = 0; i < keys.length; i++) {
              let key = keys[i]
              let site = data[key]
              site['.key'] = key
              site['customerKey'] = customerKey
              vm.sites.push(site)
            }
          }
        })
        */
      },
      loadSites (customerKey) {
        console.log('loadSites...')
        const vm = this
        // const sitesPath = 'Dealers/' + vm.$root.user['.key'] + '/Customers/' + customerKey + '/Sites'
        // const sitesRef = db.ref(sitesPath)
        vm.sites = []
        vm.sites = vm.$root.sites.filter(function (item) {
          return item.customerKey === customerKey
        })

        vm.sites = vm.sites.sort(vm.compareItems)
        /*
        sitesRef.once('value').then(function (snapItems) {
          const data = snapItems.val()
          if (data) {
            console.log(data)
            const keys = Object.keys(data)
            // vm.sites = data
            for (let i = 0; i < keys.length; i++) {
              let key = keys[i]
              let site = data[key]
              site['.key'] = key
              site['customerKey'] = customerKey
              vm.sites.push(site)
            }
          }
        })
        */
      },
      validateReport (mReport) {
        // mReport.Definition.footer = { elements: [], height: 0, visible: false }
        return mReport
      }
    }
  }
</script>

<style>
  .divReportFilter{
    padding-bottom: 10px;
  }

  .reportView {
    z-index: 200;
    min-height: 29.7cm;
  }

  .page {
    background: white;
    display: block;
    position: relative;
    min-height: 0;
    margin: 0 auto;
    padding: 0;
    margin-top: 0.5cm;
    margin-bottom: 0.5cm;
    /*box-shadow: 0 0 0.5cm rgba(0,0,0,0.5);*/
    /*page-break-before: always;
    page-break-before: always;
    page-break-after: always;
    break-before: always;
    break-after: always;
    page-break-after: always;*/
    /*page-break-inside: avoid;*/
    page-break-after: always;
    page-break-inside: avoid;
  }

    .page[size="A4"] {
      width: 21cm;
      height: 29.7cm;
      /*height: 31.0cm;*/
      /*position: relative;*/
    }

      .page[size="A4"][layout="portrait"] {
        width: 29.7cm;
        height: 21cm;
      }

    .page[size="A3"] {
      width: 29.7cm;
      height: 42cm;
    }

      .page[size="A3"][layout="portrait"] {
        width: 42cm;
        height: 29.7cm;
      }

    .page[size="A5"] {
      width: 14.8cm;
      height: 21cm;
    }

      .page[size="A5"][layout="portrait"] {
        width: 21cm;
        height: 14.8cm;
      }
</style>



// WEBPACK FOOTER //
// Reports.vue?d05d5f9a